import { ICustomer } from '@/types'
import { userDisplayLabel } from '@/utils/misc'

export const buildData = (customerData?: Partial<ICustomer>) => {
  const accountManagerLabel =
    userDisplayLabel(customerData?.accountManager) ||
    customerData?.accountManager?.id

  return {
    general_info: [
      {
        editable: false,
        label: 'id',
        name: 'id',
        type: 'text',
        className: 'w-26',
        value: customerData?.id,
      },
      {
        name: 'name',
        type: 'text',
        label: 'name',
        required: true,
        value: customerData?.name,
        className: 'w-26',
      },
      {
        type: 'text',
        name: 'phone',
        label: 'phone',
        className: 'w-26',
        value: customerData?.phone,
      },
      {
        name: 'email',
        type: 'email',
        label: 'email',
        className: 'w-26',
        value: customerData?.email,
      },
      {
        type: 'text',
        label: 'accountManager',
        className: 'w-26',
        value: accountManagerLabel,
      },
      {
        type: 'checkbox',
        required: true,
        className: 'w-26',
        name: 'is_active',
        label: 'is_active',
        value: customerData?.isActive,
      },
      {
        type: 'text',
        label: 'notes',
        name: 'notes',
        className: 'w-50',
        value: undefined,
      },
    ],
    financial_details: [
      {
        type: 'text',
        label: 'bank',
        className: 'w-26',
        value: customerData?.bank?.name,
      },
      {
        type: 'text',
        required: true,
        label: 'branch_number',
        className: 'w-26 offset-26',
        value: customerData?.branchNumber,
        name: 'branchNumber',
      },
      {
        type: 'text',
        required: true,
        className: 'w-26',
        label: 'bank_account_number',
        value: customerData?.bankAccountNumber,
        name: 'bankAccountNumber',
      },
      {
        type: 'text',
        name: 'standingOrderLimit',
        label: 'standing_order_limit',
        className: 'w-26',
        required: true,
        value: customerData?.standingOrderLimit,
      },
      {
        type: 'checkbox',
        required: true,
        name: 'should_union_invoices',
        label: 'should_union_invoices',
        value: customerData?.shouldUnionInvoices,
      },
    ],
    contact_details: [
      {
        type: 'text',
        className: 'w-26',
        name: 'contact_name',
        label: 'contact_name',
        value: customerData?.contactName,
      },
      {
        type: 'text',
        className: 'w-26',
        name: 'company_number',
        label: 'company_number',
        value: customerData?.companyNumber,
      },
      {
        type: 'text',
        name: 'address',
        label: 'address',
        className: 'w-26',
        value: customerData?.address,
      },
      {
        type: 'text',
        name: 'city',
        label: 'city',
        className: 'w-26',
        value: customerData?.city,
      },
      {
        name: 'zip',
        label: 'zip',
        type: 'number',
        className: 'w-26',
        value: customerData?.zip,
      },
      {
        type: 'text',
        className: 'w-26',
        name: 'additional_phone',
        label: 'additional_phone',
        value: customerData?.additionalPhone,
      },
      {
        name: 'fax',
        type: 'text',
        label: 'fax',
        className: 'w-26',
        value: customerData?.fax,
      },
    ],
  }
}

export const getIcon = (title: string): string => {
  return title === 'contact_details'
    ? 'icon-support'
    : title === 'financial_details'
    ? 'icon-details'
    : 'icon-information'
}
